import { CartItem, Product } from '../../types/common';
import { THREE_PLUS_MIN_PRICE } from './config';
import { isSeasonalThreePlusActive } from './date';

export function getThreePlusEligibleIds(cart: CartItem[], products: Product[], authUser: any): Set<string> {
    const eligibleIds = new Set<string>();
    if (!isSeasonalThreePlusActive()) return eligibleIds;
    if (!Array.isArray(cart) || !Array.isArray(products) || !cart.length || !products.length) return eligibleIds;
    const isEmployee = authUser?.status === 'employee';
    let totalEligibleQty = 0;
    for (const c of cart) {
        const productId = String(c.productId || '').trim();
        if (!productId) continue;
        const p = products.find((pr) => pr.id === productId);
        if (!p) continue;
        const basePrice = typeof p.price === 'number' ? p.price : NaN;
        if (!Number.isFinite(basePrice) || basePrice < THREE_PLUS_MIN_PRICE) continue;
        const sp = (p as any).specialDiscount && typeof (p as any).specialDiscount.discountedPrice === 'number' ? (p as any).specialDiscount.discountedPrice : null;
        const dp = (p as any).discount && typeof (p as any).discount.discountedPrice === 'number' ? (p as any).discount.discountedPrice : null;
        const hasEmployeeSpecial = isEmployee && typeof sp === 'number';
        const hasRegularDiscount = typeof dp === 'number';
        // НЕ применяем 3+ если уже есть скидка
        if (hasEmployeeSpecial || hasRegularDiscount) continue;
        const rawQty = Number(c.quantity);
        const qty = Number.isFinite(rawQty) && rawQty > 0 ? Math.floor(rawQty) : 1;
        if (qty <= 0) continue;
        totalEligibleQty += qty;
        eligibleIds.add(productId);
    }
    if (totalEligibleQty < 3) {
        return new Set<string>();
    }
    return eligibleIds;
}
